<template>
  <div>
    <div class="form-group"
         v-touch:swipe.stop="noSwipe">
      <vue-slider ref="slider"
                  v-model="question.GivenAnswer"
                  v-bind="options">
        <template slot="piecewise" slot-scope="{ label, active }">
            <span :class="['piecewise-style', { active }]" v-if="(label % piecewiseRatio) === 0">
              |
            </span>
        </template>
        <template slot="label" slot-scope="{ label, active }">
          <span :class="['label-style', { active }]" v-if="(label % labelRatio) === 0">
            {{ label }}
          </span>
        </template>
      ></vue-slider>
    </div>
  </div>
</template>

<script>
  import vueSlider from 'vue-slider-component'

  export default {
    components: {vueSlider},
    props: {
      question: {
        required: true,
        type: Object,
      },
      auxParam: {
        required: true,
        type: String,
      },
    },
    created () {
      if (!this.question.GivenAnswer) {
        this.question.GivenAnswer = this.question.MinimumValue
      }
      this.options.min = this.question.MinimumValue
      this.options.max = this.question.MaximumValue
      this.options.interval = 1 * this.auxParam
      let ratio = (this.question.MaximumValue - this.question.MinimumValue) / this.auxParam
      if (ratio <= 10) {
        this.piecewiseRatio = 1 * this.auxParam
        this.labelRatio = 1 * this.auxParam
      } else if (ratio <= 30) {
        this.piecewiseRatio = 1 * this.auxParam
        this.labelRatio = 2 * this.auxParam
      } else if (ratio <= 50) {
        this.piecewiseRatio = 2 * this.auxParam
        this.labelRatio = 5 * this.auxParam
      } else {
        this.piecewiseRatio = 10 * this.auxParam
        this.labelRatio = 20 * this.auxParam
      }

      let vm = this
      setTimeout(function () {
        vm.$nextTick(() => vm.$refs.slider.refresh())
      }, 500)
    },
    methods: {
      noSwipe () {
        console.info('Slider swipe prevented')
      }
    },
    data () {
      return {
        piecewiseRatio: 1,
        labelRatio: 1,
        options: {
          show: true,
          min: 0,
          max: 0,
          interval: 1,
          tooltipDir: 'top',
          width: 'auto',
          piecewise: true,
          piecewiseLabel: true,
          style: {
            marginTop: '50px',
            marginBottom: '50px'
          },
          piecewiseStyle: {
            backgroundColor: '#3A86FF',
            visibility: 'visible',
            width: '2px',
            height: '5px'
          },
          processStyle: {
            backgroundColor: '#3A86FF',
            borderColor: '#3A86FF',
          },
          tooltipStyle: {
            backgroundColor: '#3A86FF',
            borderColor: '#3A86FF',
            width: '50px',
            height: '40px'
          },
          bgStyle: {
            // backgroundColor: '#fff',
            // boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
          }
        },
      }
    },
  }
</script>

<style scoped>
  .label-style {
    font-size: 15px;
    position: absolute;
    transform: translate(-50%, -10px);
  }

  .piecewise-style {
    font-size: 10px;
  }

  .active {
    color: #3A86FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Numeric.vue